module.exports = __webpack_public_path__ + "static/media/Rectangle_6.1baa04b1.png";